import React, { Component } from "react";
import Alerter from "../Containers/AlerterConteiner";

class RouterBreadcrumbs extends Component {
	constructor (props) {
		super(props);
	}
	
	render() {
		let content="";
		if(this.props.isLoggedIn){
			content=<Alerter/>
		}
		return (
			<div className="routerbreadcrumb">
				{content}
			</div>
		)
	}
}

export default RouterBreadcrumbs;